var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0c2.21 0 4 1.79 4 4v12c0 2.21-1.79 4-4 4H4c-2.21 0-4-1.79-4-4V3c0-1.657 1.343-3 3-3h13zM2 5.83V16c0 1.105.895 2 2 2h12c1.105 0 2-.895 2-2v-3h-3c-.552 0-1-.448-1-1s.448-1 1-1h3V8c0-1.105-.895-2-2-2l-3-.001V6H3c-.35 0-.687-.06-1-.17zM16 2H3c-.552 0-1 .448-1 1s.448 1 1 1h13c.729 0 1.413.195 2.001.536L18 4c0-1.105-.895-2-2-2z",
    transform: "translate(-20 -493) translate(20 493) translate(4 4)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.4ad9480f4ad1316c05c0005c83308062.svg";
export { ForwardRef as ReactComponent };